import { withOptimizely } from '@optimizely/react-sdk';

const wrapWithOptimizely = Component => {
    return withOptimizely(Component);
};

export default wrapWithOptimizely;
